module.exports = __webpack_public_path__ + "static/media/builtinv2-Файл_000 copy copy.388db9c9.png";